import React from "react";
import PropTypes from "prop-types";
import classes from "./style/ReportHistoryPage.module.css";

const ReportHistoryPage = (props) => {
  return (
    <div className="container-fluid">
      <h5>Report History</h5>
      <b>Thanks for reporting</b>
      <p>
        Any member of the Edututs+ community can flag content to us that they
        believe violates our Community Guidelines. When something is flagged,
        it’s not automatically taken down. Flagged content is reviewed in line
        with the following guidelines:
      </p>
      <ul>
        <li>
          Content that violates our Community Guidelines is removed from
          Edututs+.
        </li>
        <li>
          Content that may not be appropriate for all younger audiences may be
          age-restricted.
        </li>
      </ul>
      <a href="">Learn more about reporting content on Edututs+.</a>

      <div className="reportHistory text-center pt-4">
        You havent submitted any reports.
      </div>
    </div>
  );
};

/* required: display name */
ReportHistoryPage.displayName = "ReportHistoryPage";

/* required: props types */
ReportHistoryPage.propTypes = {};

/* required: default props */
ReportHistoryPage.defaultProps = {};

export { ReportHistoryPage };
